import { tenantProjectRouteNames } from '@/constants/router'
import { FORM_SRC_PROJECT_CONTROL } from './consts'

const PROJECT_CONTROL_LEAVE_ROUTE_NAMES = [
  tenantProjectRouteNames.tenantProject,
  tenantProjectRouteNames.tenantProjectDetail,
]

export function isProjectControlLeaveRoute (routeName) {
  return PROJECT_CONTROL_LEAVE_ROUTE_NAMES.includes(routeName)
}

/** True when dirty is Project Control only — use Save & Continue modal. */
export function shouldUseProjectControlLeaveModal (dirtyComponents = {}) {
  const hasOtherDirty = Object.keys(dirtyComponents).some(
    key => key !== FORM_SRC_PROJECT_CONTROL && dirtyComponents[key],
  )
  if (hasOtherDirty) return false
  return !!dirtyComponents[FORM_SRC_PROJECT_CONTROL]
}
